import { connect } from 'react-redux';
import Dashboard from './pages';

const mapStateToProps = (state) => {
    return {
        user: state.user,
        role: state.role,
    }
};

export default connect(mapStateToProps)(Dashboard);
